import { createFileRoute, Outlet } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { orpc } from "@/orpc/client";
import { PartnerTermsGate } from "@/pages/partner-terms-gate/PartnerTermsGate";
import { searchParamsSchema } from "@/pages/partner-terms-gate/types";
import {
	buildTermsStatusInput,
	determineFlow,
} from "@/pages/partner-terms-gate/util";

/**
 * Partner routes layout.
 * Unlike /auth which redirects authenticated users, /partner routes
 * are accessible to anyone (partners may or may not be logged in).
 *
 * PartnerTermsGate checks if the partner has accepted global terms of service.
 */
export const Route = createFileRoute("/partner")({
	validateSearch: zodValidator(searchParamsSchema),
	beforeLoad: ({ search }) => {
		const flow = determineFlow(search);
		return { flow };
	},
	loader: async ({ context: { queryClient, flow } }) => {
		const termsStatusInput = buildTermsStatusInput(flow);
		if (termsStatusInput) {
			return await queryClient.ensureQueryData(
				orpc.partners.getTermsStatus.queryOptions({
					input: termsStatusInput,
				}),
			);
		}
		return null;
	},
	component: PartnerLayout,
});

function PartnerLayout() {
	return (
		<PartnerTermsGate>
			<Outlet />
		</PartnerTermsGate>
	);
}
